<template>
  <CardWrapper :loading="!article" class="identifiers text-white">
    <template v-if="article">
      <div class="row">
        <div class="col-8 text-h4">
          {{ article.journal_name }}
        </div>
        <div class="col-4 row items-center q-gutter-sm justify-end">
          <div class="col-auto text-subtitle2 title">
            Print identifier (ISSN)
          </div>

          <div class="col-auto text-h5">
            {{ article.print_identifier }}
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-8 text-h5">
          {{ article.publisher_name }}
        </div>
        <div class="col-4 row items-center q-gutter-sm justify-end">
          <div class="col-auto text-subtitle2 title">
            Online identifier (eISSN)
          </div>

          <div class="col-auto text-h5">
            {{ article.online_identifier }}
          </div>
        </div>
      </div>
    </template>
  </CardWrapper>
</template>

<script>
import CardWrapper from '../CardWrapper'

export default {
  components: {
    CardWrapper
  },

  props: {
    article: Object
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/styles/stylus/custom-variables'

.identifiers {
  background-color $tertiary

  .title {
    height 16px
  }
}
</style>
